<template>
  <div
    class="page-head-transition pa-0 my-0 mx-auto"
    :class="transitionPosition"
    :style="getStyle"
  >
    <img
      :src="$appConfig.appTransitionOpen"
      alt=""
      class="page-head-transition__sizer"
    >
  </div>
</template>

<script>
export default {
  name: "ComponentTransition",
  props: {
    id: {
      type: String,
    },
    transitionRotate: String,
    transitionPosition: String,
  },
  computed: {
    getStyle() {
      const src = this.$appConfig.appTransitionOpen;
      const background = this.$vuetify.theme.currentTheme.background
        || (this.$vuetify.theme.dark ? "#262b35" : "#eef1f4");

      return {
        position: "absolute",
        width: "100%",
        bottom: "-1px",
        transform: "rotate(" + this.transitionRotate + "deg)",
        backgroundColor: background,
        WebkitMaskImage: `url("${src}")`,
        maskImage: `url("${src}")`,
        WebkitMaskSize: "100% 100%",
        maskSize: "100% 100%",
        WebkitMaskRepeat: "no-repeat",
        maskRepeat: "no-repeat",
        WebkitMaskPosition: "center",
        maskPosition: "center",
        pointerEvents: "none",
      };
    },
  },
};
</script>

<style lang="scss">
.top {
  top: 0;
}
.bottom {
  bottom: 0;
}
.left {
  left: 0;
}
.right {
  right: 0;
}
.page-head-transition__sizer {
  display: block;
  width: 100%;
  visibility: hidden;
  pointer-events: none;
}
</style>
